// autogenerated
import {AthenaeumConstants, ServiceProvider, GeoCoordinate} from "@reapptor-apps/reapptor-toolkit";

export default class ScanTicketRequest {

    public shuttleInstanceLegId: string = "";

    public checkIn: boolean = false;

    public qrCode: string = "";

    public location: GeoCoordinate | null = null;

    public readonly isScanTicketRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ScanTicketRequest) || ((from as any).isScanTicketRequest === true));
    }

    public static as(from?: object | null): ScanTicketRequest | null {
        return (ScanTicketRequest.is(from)) ? from as ScanTicketRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ScanTicketRequest, "ScanTicketRequest");